export default [
  //产品管理
  {
    path: "financeProduct",
    name: { list: ["数字金融", "金融服务", "基本信息", "产品管理"] },
    component: () => import("@/views/product/index.vue"),
  },
  //申请记录
  {
    path: "financeRecord",
    name: { list: ["数字金融", "金融服务", "基本信息", "申请记录"] },
    component: () => import("@/views/record/index.vue"),
  },
  //机构管理
  {
    path: "financeOrganizational",
    name: { list: ["数字金融", "金融服务", "基本信息", "机构管理"] },
    component: () => import("@/views/organizational/index.vue"),
  },
  // {
  //   path: "detail",
  //   name: { list: ["数字金融", "金融服务", "基本信息", "产品管理详情"] },
  //   component: () => import("@/views/product/detail.vue"),
  // },
];
